import { useEffect, useState } from 'react';
import AdminLayout from '@/components/admin/AdminLayout';
import EmptyState from '@/components/admin/EmptyState';
import { adminApi } from '@/lib/api';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Save } from 'lucide-react';
import { toast } from 'sonner';

const LABELS = {
    hero_headline: { label: 'Hero — Headline', kind: 'short' },
    hero_subheadline: { label: 'Hero — Subheadline', kind: 'long' },
    hero_cta_primary_label: { label: 'Hero — CTA primario', kind: 'short' },
    hero_cta_secondary_label: { label: 'Hero — CTA secundario', kind: 'short' },
    quick_strip_text: { label: 'CTA rápido — Texto', kind: 'short' },
    about_title: { label: 'Nosotros — Título', kind: 'short' },
    about_body: { label: 'Nosotros — Texto', kind: 'long' },
    about_mission: { label: 'Nosotros — Misión', kind: 'long' },
    about_vision: { label: 'Nosotros — Visión', kind: 'long' },
    safety_title: { label: 'Seguridad — Título', kind: 'short' },
    safety_body: { label: 'Seguridad — Texto', kind: 'long' },
    contact_title: { label: 'Contacto — Título', kind: 'short' },
    contact_body: { label: 'Contacto — Texto', kind: 'long' },
    gallery_title: { label: 'Galería — Título', kind: 'short' },
    gallery_subtitle: { label: 'Galería — Subtítulo', kind: 'short' },
    seo_title: { label: 'SEO — Title', kind: 'short' },
    seo_description: { label: 'SEO — Description', kind: 'long' },
};

export default function AdminContentPage() {
    const [values, setValues] = useState({});
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(null);
    useEffect(() => { adminApi.content.list().then((items) => { const map = {}; for (const it of items) map[it.key] = it.value; setValues(map); }).finally(() => setLoading(false)); }, []);
    const set = (k, v) => setValues((s) => ({ ...s, [k]: v }));
    const save = async (k) => { setSaving(k); try { await adminApi.content.upsert(k, values[k]); toast.success('Guardado'); } catch { toast.error('No se pudo guardar'); } finally { setSaving(null); } };
    if (loading) return <AdminLayout title="Contenido"><div className="h-64 bg-white rounded-2xl border border-border animate-pulse" /></AdminLayout>;
    const keys = Object.keys(LABELS);
    return (
        <AdminLayout title="Contenido del sitio">
            <p className="text-sm text-muted-foreground mb-4">Edita los textos principales del sitio público. Los cambios se reflejan al refrescar el sitio.</p>
            {keys.length === 0 ? <EmptyState /> : (
                <div className="grid gap-4 md:grid-cols-2">
                    {keys.map((k) => (
                        <div key={k} className="rounded-2xl bg-white border border-border p-4 shadow-[var(--shadow-soft)]">
                            <Label>{LABELS[k].label}</Label>
                            {LABELS[k].kind === 'long' ? (
                                <Textarea rows={4} value={values[k] || ''} onChange={(e) => set(k, e.target.value)} className="mt-2" data-testid={`content-${k}`} />
                            ) : (
                                <Input value={values[k] || ''} onChange={(e) => set(k, e.target.value)} className="mt-2" data-testid={`content-${k}`} />
                            )}
                            <button onClick={() => save(k)} disabled={saving === k} className="mt-3 inline-flex items-center gap-2 rounded-lg bg-primary text-primary-foreground px-3 py-1.5 text-sm disabled:opacity-60" data-testid={`content-save-${k}`}><Save className="size-4" /> {saving === k ? 'Guardando…' : 'Guardar'}</button>
                        </div>
                    ))}
                </div>
            )}
        </AdminLayout>
    );
}
